import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View } from 'react-native';
import { Divider, Icon, Text, useTheme } from '@ui-kitten/components';
import lodashIsEmpty from 'lodash/isEmpty';

import Button from '../../../Components/Button';
import ListItem from '../../../Components/ListItem';
import { removeRecentlySearch } from '../../../RTK/search';
import ThemeColor from '../../../Theme/colors';
import ThemeStyle from '../../../Theme/styles';
import constants from '../../../Config/constants';

import { TYPE_STATUS, SEARCH_SELECTOR } from '../constants';
import { TYPE } from '../types';

type Props = {
  type: TYPE;
  onPress: (data: string) => void;
};

const RecentlyViewedSection = ({ type, onPress }: Props) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const recentlySearch = useSelector(SEARCH_SELECTOR[type]);

  const color = theme[`color-${TYPE_STATUS[type]}-500`];

  const _onSearchRemove = (search) => () => {
    dispatch(removeRecentlySearch({ value: search, type }));
  };

  if (lodashIsEmpty(recentlySearch)) {
    return null;
  }

  return (
    <View
      testID="recentlyViewed"
      style={[ThemeStyle.pageHorizontalSpacing, ThemeStyle.spacingTopMedium]}
    >
      <View
        style={[
          ThemeStyle.flexDirectionRowSpaceBetween,
          ThemeStyle.alignItemsCenter,
        ]}
      >
        <View style={ThemeStyle.flexDirectionRowCenter}>
          <Icon
            name="history"
            pack="fa"
            fill={color}
            style={[{ width: 20, height: 20 }, ThemeStyle.spacingRightMedium]}
          />
          <Text category={constants.isWeb ? 'p1' : 's1'}>Recent Searches</Text>
        </View>

        <Button hitSlop={10} onPress={_onSearchRemove('')} plain>
          <Text
            category="p2"
            status={TYPE_STATUS[type]}
            style={ThemeStyle.underline}
          >
            Clear All
          </Text>
        </Button>
      </View>

      {recentlySearch.map((item, index) => (
        <Fragment key={index}>
          <ListItem
            contentContainerStyle={ThemeStyle.pageVerticalSpacingMedium}
            testID={`recentlyButton${index}`}
            title={item}
            rightIcon={{
              color: ThemeColor.darkGray,
              name: 'close',
              size: 20,
              onPress: _onSearchRemove(item),
            }}
            onPress={() => onPress(item)}
          />
          {index !== recentlySearch.length - 1 && (
            <Divider style={ThemeStyle.divider} />
          )}
        </Fragment>
      ))}
    </View>
  );
};
export default RecentlyViewedSection;
